import { createElement as rc, useMemo } from 'react';
import DropDownButton from './DropDownButton';
import styleToVariant from 'lib_ui-primitives/src/styling/styleToVariant';
import styleToColor from 'lib_ui-primitives/src/styling/styleToColor';

function MenuButton({
    hNode = {},
    actionPayload,
    variant: overrideVariant = hNode.variant,
    color: overrideColor = hNode.color,
    size = hNode.size ?? 'sm',
    children,
    currentRoute,
    // show icons in menu items by default
    icons = true,
    className,
    ...otherProps
}) {
    const {
        id,
        title,
        iconName,
        buttonStyle,
        namespace,
        relation,
        withSelection,
        type,
        style,
        displayTitleOnButton = true
    } = hNode;

    const variant =
        overrideVariant ?? (withSelection ? 'tertiary' : (styleToVariant(buttonStyle ?? style) ?? 'primary'));
    const color = overrideColor ?? (withSelection ? 'primary' : (styleToColor(buttonStyle ?? style) ?? 'primary'));

    const enhancedChildren = useMemo(() => {
        if (!children) return [];
        const childrenArray = Array.isArray(children) ? children : [children];
        return childrenArray.map((child, index) => {
            if (child && child.props && child.props.hNode) {
                return rc(child.type, {
                    ...child.props,
                    key: child.key || index,
                    currentRoute,
                    showIcons: icons,
                    actionPayload: { ...actionPayload, ...child.props.actionPayload },
                    hNode: {
                        namespace,
                        relation,
                        type,
                        withSelection,
                        ...child.props.hNode
                    }
                });
            }
            return child;
        });
    }, [children, currentRoute, actionPayload, icons, namespace, relation, type, withSelection]);

    return rc(
        DropDownButton,
        {
            id,
            icon: iconName,
            title,
            text: displayTitleOnButton ? title : undefined,
            value: title,
            size,
            color,
            variant,
            className: `${className || ''} action-button`.trim(),
            buttonStyle: buttonStyle ?? style ?? (withSelection ? 'tertiary' : 'round'),
            menuClassName: 'action-menu',
            ...otherProps
        },
        enhancedChildren
    );
}

export default MenuButton;
